import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { IBoardHistoryAppointmentTimeZone } from "../../../../../../../../../models/masterAppointment/IAppointmentBoard";
import { useAppDispatch } from "../../../../../../../../../redux/hooks";
import { setShowPopUpMasterAppointmentTimeZone } from "../../../../../../../../../redux/reducers/masterAppointment/appointmentBoard/appointmentDockTimeZone/form";
import { ButtonPrimaryInverseWithBorder } from "../../../../../../../../common/buttons/buttons";
import { TitleH5 } from "../../../../../../../../common/titles/titles";
import { AppointmentTimeZonesStyles } from "./containerStyle.jss";
import { MasterBoardHistoryAppointmentTimeZoneControllerForm } from "./controller/controller";
import { MasterBoardHistoryAppointmentTimeZoneList } from "./list/list";
import { ColorType } from "../../../../../../../../../common/enum/ColorType";
import { PopUpCodes } from "../../../../../../../../../common/enum/PopUpCodes";
interface IMasterAppointmentTimeZonesControllerProps {
    list: IBoardHistoryAppointmentTimeZone[];
}

export const AppointmentTimeZonesController: React.FC<IMasterAppointmentTimeZonesControllerProps> = ({ list }) => {
    const { t } = useTranslation("common", { keyPrefix: "MASTER_APPOINTMENT.APPOINTMENT_BOARD.TITLES" });
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const style = AppointmentTimeZonesStyles({ theme });
    return (
        <div className={style.container}>
            <div className={style.header}>
                <TitleH5
                    title={t("TIMEZONES")}
                    bold={true}
                    color={ColorType.primary}
                />
                <ButtonPrimaryInverseWithBorder
                    handleClick={() => {
                        dispatch(setShowPopUpMasterAppointmentTimeZone(PopUpCodes.CREATE));
                    }}
                    title={`+ ${t("ADD")}`}
                />
            </div>

            <MasterBoardHistoryAppointmentTimeZoneList list={list} />
            <MasterBoardHistoryAppointmentTimeZoneControllerForm />
        </div>
    );
};
